"use client";

// Pending external-wallet proof attempts, never proof or connected accounts.
const recordings = new Map<string, Promise<boolean>>();
const readers = new Map<string, Set<(pending: Promise<boolean>) => void>>();

/** Key only the actual sign-in response or explicitly selected message signer. */
export function trackConnectProofRecording(
  address: string,
  recording: Promise<boolean>
) {
  const pending = recording.catch(() => false);
  recordings.set(address, pending);
  for (const reader of readers.get(address) ?? []) reader(pending);
  void pending.finally(() => {
    if (recordings.get(address) === pending) recordings.delete(address);
  });
}

/** Keep only this identity read's overlapping write, even if it settles first. */
export function watchConnectProofRecording(address: string) {
  let pending = recordings.get(address);
  const read = (next: Promise<boolean>) => {
    pending = next;
  };
  const watching = readers.get(address) ?? new Set();
  readers.set(address, watching);
  watching.add(read);
  return {
    pending: () => pending,
    release: () => {
      watching.delete(read);
      if (!watching.size && readers.get(address) === watching)
        readers.delete(address);
    },
  };
}
